<template>
  <!--
      作者：gmshop
      时间：2022-12-2
      描述：发票管理-发票详情
  -->
  <div class="user pb50" v-loading="loading">
    <div class="product-content">
      <!--发票信息-->
      <div class="common-form">发票信息</div>
      <div class="refund-detail-content">
        <el-row>
          <el-col :span="5">
            <div class="pb16">
              <span class="gray9">发票类型：</span>
              {{ detail.invoice_type.text }}
            </div>
          </el-col>
          <el-col :span="5">
            <div class="pb16">
              <span class="gray9">抬头类型：</span>
              {{ detail.header_type.text }}
            </div>
          </el-col>
          <el-col :span="5">
            <div class="pb16">
              <span class="gray9">抬头名称：</span>
              {{ detail.name }}
            </div>
          </el-col>
          <el-col :span="5">
            <div class="pb16">
              <span class="gray9">纳税人识别码：</span>
              {{ detail.number }}
            </div>
          </el-col>
          <el-col :span="5">
            <div class="pb16">
              <span class="gray9">申请开票金额：</span>
              {{ detail.amount }}
            </div>
          </el-col>
          <el-col :span="5">
            <div class="pb16">
              <span class="gray9">电子邮箱：</span>
              {{ detail.email }}
            </div>
          </el-col>
          <el-col :span="5">
            <div class="pb16">
              <span class="gray9">注册地址：</span>
              {{ detail.address }}
            </div>
          </el-col>
          <el-col :span="5">
            <div class="pb16">
              <span class="gray9">注册电话：</span>
              {{ detail.phone }}
            </div>
          </el-col>
          <el-col :span="5">
            <div class="pb16">
              <span class="gray9">开户银行：</span>
              {{ detail.bank }}
            </div>
          </el-col>
          <el-col :span="5">
            <div class="pb16">
              <span class="gray9">银行账户：</span>
              {{ detail.bank_account }}
            </div>
          </el-col>
          <el-col :span="5">
            <div class="pb16">
              <span class="gray9">收票人姓名：</span>
              {{ detail.taker_name }}
            </div>
          </el-col>
          <el-col :span="5">
            <div class="pb16">
              <span class="gray9">收票人所在省：</span>
              {{ detail.region.province }}
            </div>
          </el-col>
          <el-col :span="5">
            <div class="pb16">
              <span class="gray9">收票人所在市：</span>
              {{ detail.region.city }}
            </div>
          </el-col>
          <el-col :span="5">
            <div class="pb16">
              <span class="gray9">收票人所在区：</span>
              {{ detail.region.region }}
            </div>
          </el-col>
          <el-col :span="5">
            <div class="pb16">
              <span class="gray9">收票人详细地址：</span>
              {{ detail.address_detail }}
            </div>
          </el-col>
          <el-col :span="5">
            <div class="pb16">
              <span class="gray9">开票状态：</span>
              {{ detail.status.text }}
            </div>
          </el-col>
          <el-col :span="5">
            <div class="pb16">
              <span class="gray9">申请时间：</span>
              {{ detail.apply_time }}
            </div>
          </el-col>
          <el-col :span="5">
            <div class="pb16">
              <span class="gray9">开票时间：</span>
              {{ detail.invoicing_time }}
            </div>
          </el-col>
        </el-row>
      </div>

      <!--订单信息-->
      <div class="common-form mt16">订单信息</div>
      <div class="table-wrap">
        <el-table size="small" :data="detail.orderRecord" border style="width: 100%">
          <el-table-column prop="orderM.order_no" label="订单号"></el-table-column>
          <el-table-column prop="orderM.pay_price" label="实际支付金额"></el-table-column>
          <el-table-column prop="orderM.order_price" label="订单金额"></el-table-column>
          <el-table-column prop="orderM.express_price" label="运费金额"></el-table-column>
          <el-table-column prop="" label="操作">
            <template slot-scope="scope">
              <el-button size="mini" href="/" target="_blank" @click="gotoPage(scope.row)">订单详情</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!--商家审核-->
      <div v-if="detail.status.value == 10">
        <div class="common-form mt16">商家审核</div>
        <el-form size="small" ref="form" :model="form" label-width="80px" class="demo-ruleForm">
          <el-form-item label="审核状态">
            <el-radio-group v-model="form.status">
              <el-radio :label="20">同意</el-radio>
              <el-radio :label="30">拒绝</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="发票网址" v-if="form.status == 20">
            <el-input v-model="form.file_url" class="max-w460"></el-input>
          </el-form-item>
          <el-form-item :label="form.status == 20?'备注':'拒绝原因'" prop="reply" :rules="[{required: form.status == 30?true:false,message: '请输入拒绝原因'}]">
            <el-input type="textarea" v-model="form.reply" class="max-w460"></el-input>
          </el-form-item>
        </el-form>
      </div>

      <!-- 审核结果 -->
      <div v-if="detail.status.value != 10 ">
        <div class="common-form mt16">审核结果</div>
        <el-row>
          <el-col :span="5">
            <div class="pb16">
              <span class="gray9">开票状态：</span>
              {{ detail.status.text }}
            </div>
          </el-col>
          <el-col :span="5" v-if="detail.status.value == 20 ">
            <div class="pb16">
              <span class="gray9">发票网址：</span>
              {{ detail.file_url }}
            </div>
          </el-col>
          <el-col :span="14">
            <div class="pb16">
              <span class="gray9">回复：</span>
              {{ detail.reply }}
            </div>
          </el-col>
        </el-row>
      </div>
    </div>

    <div class="common-button-wrapper">
      <el-button size="small" type="info" @click="cancelFunc">取消 / 返回上一页</el-button>
      <!--商家审核-->
      <template v-if="detail.status.value == 10">
        <el-button size="small" type="primary" @click="onSubmit(detail.order_invoice_id)">确认审核</el-button>
      </template>
    </div>
  </div>
</template>
<script>
import OrderApi from '@/api/order.js';
export default {
  data() {
    return {
      /*详情*/
      detail: {
        orderRecord: [],
        invoice_type: {},
        header_type: {},
        name: '',
        number: '',
        amount: '',
        email: '',
        address: '',
        phone: '',
        bank: '',
        bank_account: '',
        taker_name: '',
        region: {},
        address_detail: '',
        status: {},
        apply_time: '',
        invoicing_time: '',
        order_invoice_id: 0
      },
      form: {
        status: 20,
        file_url: '',
        reply: '',
      },
      multipleSelection: [],
      order_invoice_id: 0,
      loading: true
    };
  },
  created() {
    /*获取列表*/
    this.getData();
  },
  methods: {
    /*获取列表*/

    getData() {
      let self = this;
      let order_invoice_id = this.$route.query.order_invoice_id;
      OrderApi.getInvoiceDetail(
        {
          order_invoice_id: order_invoice_id
        },
        true
      )
        .then(res => {
          self.detail = res.data.detail;
          self.loading = false;
        })
        .catch(error => {});
    },

    /*跳转订单详情*/
    gotoPage(row) {
      let self = this;
      this.$router.push({
        path: '/order/order/detail',
        query: {
          order_id: row.order_id
        }
      });
    },

    /*审核*/
    onSubmit(e) {
      let self = this;
      console.log(self.$refs.form)
      self.$refs.form.validate((valid) =>
      {
        if (valid) {
          let form = self.form;
          let order_invoice_id = e;
          OrderApi.InvoiceAudit(
            {
              status: form.status,
              file_url: form.file_url,
              reply: form.reply,
              order_invoice_id: order_invoice_id,
            },
            true
          )
            .then(data => {
              self.$message({
                message: '恭喜你，操作成功',
                type: 'success'
              });
              this.getData();
            })
            .catch(error => {});
        }
      });
    },

    /*取消*/
    cancelFunc() {
      this.$router.back(-1);
    }
  }
};
</script>
<style>
.apply-reason {
  padding: 16px;
  background: #fff4f4;
  border: 1px solid #f6e6e6;
}
.apply-reason-box .pic {
  width: 100px;
  height: 100px;
  margin-right: 4px;
  border: 1px solid #d1d5dd;
}
.apply-reason-box .pic img {
  width: 98px;
  height: 98px;
  object-fit: contain;
}
</style>



// WEBPACK FOOTER //
// src/views/order/invoice/detail.vue